"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Features = void 0;
var _react = _interopRequireDefault(require("react"));
var _BasePrice = require("b2b-components/theme/components/BasePrice");
var _Price = require("b2b-components/theme/components/Price");
var _classnames = _interopRequireDefault(require("classnames"));
var _Actions = require("./Actions");
var _Table = require("./Table");
require("./Features.scss");
var Features = function Features(_ref) {
  var basePrice = _ref.basePrice,
    category = _ref.category,
    className = _ref.className,
    renderHiddenPrice = _ref.renderHiddenPrice,
    manufacturerSku = _ref.manufacturerSku,
    onCategoryClick = _ref.onCategoryClick,
    price = _ref.price,
    renderActions = _ref.renderActions,
    sku = _ref.sku,
    renderSku = _ref.renderSku,
    text = _ref.text,
    areActionsVisible = _ref.areActionsVisible;
  var Actions = Features.Actions,
    Price = Features.Price;
  var rootClassName = (0, _classnames["default"])('cds-ProductBox-Features', className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement(_Table.Table, {
    category: category,
    manufacturerSku: manufacturerSku,
    onCategoryClick: onCategoryClick,
    price: price,
    sku: sku,
    renderSku: renderSku,
    text: text
  }), /*#__PURE__*/_react["default"].createElement("div", null, renderHiddenPrice, !renderHiddenPrice && /*#__PURE__*/_react["default"].createElement(Price, {
    className: "cds-ProductBox-Price",
    currency: "CHF",
    price: price
  }), basePrice && /*#__PURE__*/_react["default"].createElement(_BasePrice.BasePrice, {
    unit: basePrice.unit,
    price: basePrice.price,
    currency: "CHF"
  })), /*#__PURE__*/_react["default"].createElement(Actions, {
    areActionsVisible: areActionsVisible
  }, renderActions));
};
exports.Features = Features;
Features.Actions = _Actions.Actions;
Features.Price = _Price.Price;
Features.BasePrice = _BasePrice.BasePrice;
Features.Table = _Table.Table;